import { render } from "./CopyIcon.vue?vue&type=template&id=5267dd71"
import script from "./CopyIcon.vue?vue&type=script&lang=js"
export * from "./CopyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__